import { useState, useEffect } from 'react';
import { useRouter } from 'next/router'
import Session from 'components/session/session';



export default function SessionPage() {
    const router = useRouter()
    const [sessionId, setSessionId] = useState(null);
    const [defaultAccessCode, setDefaultAccessCode] = useState(null);

    useEffect(() => {
        if (!router.query) {
            return;
        }
        setSessionId(router.query.sessionId)
        setDefaultAccessCode(router.query.accessCode)
    }, [router.query])

    return (
        <Session sessionId={sessionId} defaultAccessCode={defaultAccessCode} />
    );
}